import * as React from 'react';
import './BoxProfile.scss';
import { createActionLogout } from '../../Actions/Session/Actions';
import { connect } from 'react-redux';
import { IStateApp } from '../../Reducers/index';

export interface IBoxProfileProps {
	onToggle: () => void;
	open: boolean;
	icon: JSX.Element;
	classProfile: string;
	profile: string;
	name: string;
	email: string;
	onLogout: () => void;
	onChangePass: () => void;
}


class BoxProfile extends React.Component<IBoxProfileProps> {
	render() {
		return (
			<div
				className="BoxProfile"
				style={{ display: this.props.open ? 'flex' : 'none' }}
			>
				<div className="BoxProfile-logo">
					<div className={this.props.classProfile}>
						{this.props.icon}

						<p className={this.props.classProfile}>{this.props.profile}</p>
					</div>
				</div>
				<div className="BoxProfile-content">
                    <div className="BoxProfile-content-item">
                        <label>Nombre de Usuario</label>
                        <div>{this.props.name}</div>
                    </div>
                    <div className="BoxProfile-content-item">
                        <label>Rol</label>
                        <div>{this.props.profile}</div>
                    </div>
                    <div className="BoxProfile-content-item">
                        <label>Correo Corporativo</label>
                        <div>{this.props.email}</div>
                    </div>
                </div>
				<div className="BoxProfile-footer">
					<div className="btn" onClick={this.props.onChangePass}>Cambiar Contraseña</div>
					<div className="btn" onClick={this.props.onLogout}>Cerrar Sesión</div>
				</div>
			</div>
		);
	}
}

const mapProps = (state: IStateApp) => ({});

const mapActions = (dispatch: any) => ({
	onLogout: () => dispatch(createActionLogout())
});

export default connect(mapProps, mapActions)(BoxProfile);
